export const minifyJSON = (inputData) => {
  try {
    return { minified: JSON.stringify(JSON.parse(inputData), null, 0), isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid JSON input.', isError: true };
  }
};

export const minifyXML = (inputData) => {
  try {
    // Validate using DOMParser before minifying
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(inputData, 'application/xml');
    if (xmlDoc.getElementsByTagName('parsererror').length > 0) {
      return { minified: 'Error: Invalid XML input.', isError: true };
    }
    // Remove whitespace-only gaps between tags, preserve text node content
    const minified = inputData
      .replace(/>\s+</g, '><')
      .trim();
    return { minified, isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid XML input.', isError: true };
  }
};

export const minifyHTML = (inputData) => {
  try {
    const minified = inputData
      .replace(/<!--[\s\S]*?-->/g, '')  // remove HTML comments
      .replace(/>\s+</g, '><')          // remove whitespace-only gaps between tags
      .trim();
    return { minified, isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid HTML input.', isError: true };
  }
};

export const minifyCSS = (inputData) => {
    try {
        const minified = inputData
            .replace(/\/\*[\s\S]*?\*\//g, '')     
            .replace(/\s*{\s*/g, '{')
            .replace(/\s*}\s*/g, '}')
            .replace(/\s*;\s*/g, ';')
            .replace(/\s*:\s*/g, ':')
            .replace(/\s*,\s*/g, ',')
            .replace(/\s+/g, ' ')                 
            .replace(/\n/g, '')                   
            .trim();
        return { minified, isError: false };
    } catch (error) {
        return { minified: 'Error: Invalid CSS input.', isError: true };
    }
};

export const minifyJs = (inputData) => {
  try {
    // Step 1: extract string/template literals so their content is never touched
    const strings = [];
    let processed = inputData;

    processed = processed.replace(/`(?:[^`\\]|\\.)*`/g, (m) => { strings.push(m); return `__STR${strings.length - 1}__`; });
    processed = processed.replace(/"(?:[^"\\]|\\.)*"/g,  (m) => { strings.push(m); return `__STR${strings.length - 1}__`; });
    processed = processed.replace(/'(?:[^'\\]|\\.)*'/g,  (m) => { strings.push(m); return `__STR${strings.length - 1}__`; });

    // Step 2: minify structural code
    const minified = processed
      .replace(/\/\/.*(?=[\n\r])/g, '')                       // remove single-line comments
      .replace(/\/\*[\s\S]*?\*\//g, '')                       // remove block comments
      .replace(/\s*([{};:,+<>=!&|()[\]])\s*/g, '$1')         // remove spaces around operators
      .replace(/\n+/g, '')                                    // remove newlines
      .replace(/\s{2,}/g, ' ')                               // collapse multiple spaces
      .trim();

    // Step 3: restore strings
    const result = minified.replace(/__STR(\d+)__/g, (_, i) => strings[parseInt(i)]);

    return { minified: result, isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid JavaScript input.', isError: true };
  }
};

// TypeScriptMinifier.js
export const minifyTypeScript = (tsCode) => {
  try {
    if (!tsCode) return { convertedData: '', isError: false };

    // Simple minification: remove newlines, extra spaces, and comments
    let minified = tsCode
      .replace(/\/\/.*$/gm, '') // remove single-line comments
      .replace(/\/\*[\s\S]*?\*\//g, '') // remove block comments
      .replace(/\s+/g, ' ') // collapse whitespace
      .replace(/\s*([{};,:])\s*/g, '$1') // remove spaces around symbols
      .trim();

    return { convertedData: minified, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid TypeScript code', isError: true };
  }
};

// SqlMinifier.js
export const minifySQL = (sqlCode) => {
  try {
    if (!sqlCode) return { convertedData: '', isError: false };

    // Remove comments, extra spaces, and newlines
    let minified = sqlCode
      .replace(/--.*$/gm, '') // remove single-line comments
      .replace(/\/\*[\s\S]*?\*\//g, '') // remove block comments
      .replace(/\s+/g, ' ') // collapse whitespace
      .replace(/\s*([(),;])\s*/g, '$1') // remove spaces around symbols
      .trim();

    return { convertedData: minified, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid SQL code', isError: true };
  }
};

// YamlMinifier.js
export const minifyYAML = (yamlCode) => {
  try {
    if (!yamlCode) return { convertedData: '', isError: false };

    // Remove comments and empty lines, collapse spaces
    let minified = yamlCode
      .replace(/#.*$/gm, '') // remove comments
      .split('\n')
      .map(line => line.trim())
      .filter(line => line) // remove empty lines
      .join('\n');

    return { convertedData: minified, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid YAML', isError: true };
  }
};
